/**
 * Copyright 2026, IntraLinks, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
  IlCard,
  IlIconInitializer,
  IlStates,
  IlLoading
} from 'il-framework-component';
import { useTranslation } from 'react-i18next';
import Wrapper from '../../../app/shared/components/Wrapper/Wrapper';
import { getConfig } from '../../../app/shared/utils/config.util';
import { DEFAULT_POPUP_CLOSE_TIME, I18nNamespaces } from '../../../app/shared/utils/constants.util';
import Repos from '../../../infrastructure/repositories/Repos';
import styles from './MissingParamsErrorPage.scss';

const MissingParamsErrorPage: React.FC = () => {
  const { t, ready: i18nReady } = useTranslation(I18nNamespaces.LOA_ENRICHMENT);
  const [secondsLeft, setSecondsLeft] = useState(DEFAULT_POPUP_CLOSE_TIME);

  const { iamHost } = getConfig();
  const loginUrl = `${iamHost}/idp/login`;

  const logoutAndRedirect = () => {
    Repos.instance.logoutRepository.logout().finally(() => {
      window.location.replace(loginUrl);
    });
  };

  useEffect(() => {
    if (!i18nReady) return undefined;

    if (secondsLeft <= 0) {
      logoutAndRedirect();
      return undefined;
    }

    const id = window.setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    // eslint-disable-next-line consistent-return
    return () => window.clearTimeout(id);
  }, [i18nReady, secondsLeft]);

  if (!i18nReady) return <IlLoading withOverlay />;

  return (
    <>
      <IlIconInitializer />
      <Wrapper>
        <IlCard className={styles.cardForm}>
          <div className={styles.stateSectionContainer}>
            <IlStates
              illustration='error'
              title={t('loaEnrichment.common.errors.loaFlowErrorPageTitle')}
              description={t('loaEnrichment.common.errors.missingApplicationId')}
            />
          </div>
          <div className={styles.footerContainer}>
            <p className={styles.helpText}>
              {t('loaEnrichment.sessionResult.autoRedirectIn', { seconds: secondsLeft })}
            </p>
          </div>
        </IlCard>
      </Wrapper>
    </>
  );
};

export default MissingParamsErrorPage;
